import React, {useContext, useEffect} from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import { Loading } from './loading'
import RootStore from '../../store/RootStore'

export const SigninSilentCallback = () => {
  const { authStore } = RootStore
  const { signinSilentCallback } = useContext(AuthContext)

  useEffect(() => {
    async function handleCallback() {
      try {
        const renewedUser = await signinSilentCallback()
        if (renewedUser !== null) {
          await authStore.setUserSSO(renewedUser)
        }
      } catch (err) {
        console.error('Silent sign-in callback error:', err)
      }
    }

    handleCallback()
  }, [authStore, signinSilentCallback])

  return <Loading />
}
